import type { ProductInterface } from '../types/front.graphql';

// @TODO: should move to catalog service
export const isProductInStock = (product: ProductInterface) => {
    return product?.stock_status === 'IN_STOCK';
};
